import { createContext, FC, PropsWithChildren, useContext, useMemo, useState } from "react";

export type ColorMode = "light" | "dark";

type ColorModeContextValue = {
  mode: ColorMode;
  toggleColorMode: () => void;
};

const ColorModeContext = createContext<ColorModeContextValue>({
  mode: "light",
  toggleColorMode: () => {},
});

export const useColorMode = (): ColorModeContextValue => useContext(ColorModeContext);

const getStoredMode = (): ColorMode => {
  const stored = localStorage.getItem("color-mode");
  return stored === "dark" ? "dark" : "light";
};

export const ColorModeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [mode, setMode] = useState<ColorMode>(getStoredMode);

  const value = useMemo(
    () => ({
      mode,
      toggleColorMode: () =>
        setMode((prev) => {
          const next = prev === "light" ? "dark" : "light";
          localStorage.setItem("color-mode", next);
          return next;
        }),
    }),
    [mode]
  );

  return <ColorModeContext.Provider value={value}>{children}</ColorModeContext.Provider>;
};
